export default __webpack_public_path__ + "static/media/Success.a261ec33.svg";